import React from "react";
import Section from "../../../components/section";
import Text from "../../../components/text";
import classes from "./TandCView.module.css";

const TandCView = () => {
  const data = [
    {
      header: "Introduction",
      text: [
        "These Website Standard Terms and Conditions written on this webpage shall manage your use of our website, Webiste Name accessible at Website.com.",
        "These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions.",
        "Minors or people below 18 years old are not allowed to use this Website",
      ],
    },
    {
      header: "Intellectual Property Rights",
      text: [
        "Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.",
        "You are granted limited license only for purposes of viewing the material contained on this Website.",
      ],
    },
    {
      header: "Restrictions",
      text: [
        "You are specifically restricted from all of the following: publishing any Website material in any other media. selling, sublicensing and/or otherwise commercializing any Website material, publicly performing and/or showing any Website material, using this Website in any way that is or may be damaging to this Website.",
        "using this Website in any way that impacts user access to this Website; using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity; engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website; using this Website to engage in any advertising or marketing. Certain areas of this Website are restricted from being access by you and Company Name may further restrict access by you to any areas of this Website, at any time, in absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.",
      ],
    },
    {
      header: "Your Content",
      text: [
        "These Website Standard Terms and Conditions written on this webpage shall manage your use of our website, Webiste Name accessible at Website.com.",
        "These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions.",
        "Minors or people below 18 years old are not allowed to use this Website",
      ],
    },
    {
      header: "No warranties",
      text: [
        "Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.",
        "You are granted limited license only for purposes of viewing the material contained on this Website.",
      ],
    },
    {
      header: "Limitation of liability",
      text: [
        "You are specifically restricted from all of the following: publishing any Website material in any other media. selling, sublicensing and/or otherwise commercializing any Website material, publicly performing and/or showing any Website material, using this Website in any way that is or may be damaging to this Website.",
        "using this Website in any way that impacts user access to this Website; using this Website contrary to applicable laws and regulations, or in any way may cause harm to the Website, or to any person or business entity; engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website; using this Website to engage in any advertising or marketing. Certain areas of this Website are restricted from being access by you and Company Name may further restrict access by you to any areas of this Website, at any time, in absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality as well.",
      ],
    },
    {
      header: "Indemnification",
      text: [
        "These Website Standard Terms and Conditions written on this webpage shall manage your use of our website, Webiste Name accessible at Website.com.",
        "These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed to accept all terms and conditions written in here. You must not use this Website if you disagree with any of these Website Standard Terms and Conditions.",
        "Minors or people below 18 years old are not allowed to use this Website",
      ],
    },
    {
      header: "Severability",
      text: [
        "Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.",
        "You are granted limited license only for purposes of viewing the material contained on this Website.",
      ],
    },
    {
      header: "Variation of Terms",
      text: [
        "Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.",
        "You are granted limited license only for purposes of viewing the material contained on this Website.",
      ],
    },
    {
      header: "Assignment",
      text: [
        "Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.",
        "You are granted limited license only for purposes of viewing the material contained on this Website.",
      ],
    },
    {
      header: "Entire Agreement",
      text: [
        "Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.",
        "You are granted limited license only for purposes of viewing the material contained on this Website.",
      ],
    },
    {
      header: "Governing Law & Jurisdiction",
      text: [
        "Other than the content you own, under these Terms, Company Name and/or its licensors own all the intellectual property rights and materials contained in this Website.",
        "You are granted limited license only for purposes of viewing the material contained on this Website.",
      ],
    },
  ];

  return (
    <>
      <Section className="">
        <div>
          <Text type="H1" className="" text="Terms and Conditions" />
        </div>
        <div className={`row ${classes.mt}`}>
          <div className="col-12 col-md-4" style={{}}>
            <div style={{ backgroundColor: "#f1eaff",padding:10 }}>
              <ol>
                {data.map((item) => (
                  <li key={item.header} className="" aria-current="true">
                    <a
                      href={`#${item.header}`}
                      style={{ textDecoration: "none", color: "#160546" }}
                    >
                      <Text type="H5" className="" text={item.header} />
                    </a>
                  </li>
                ))}
              </ol>
            </div>
          </div>
          <div
            data-bs-spy="scroll"
            data-bs-target="#list-example"
            data-bs-offset="0"
            tabindex="0"
            className="col-12 col-md-8 scrollspy-example"
          >
            {data.map((item) => (
              <>
                <div id={item.header} key={item.header}>
                  <Text type="H2" className="" text={item.header} />
                  {item.text.map((text) => (
                    <Text key={item.header} type="PARAGRAPH" text={text} />
                  ))}
                </div>
              </>
            ))}
          </div>
        </div>
      </Section>
    </>
  );
};

export default TandCView;
